import debounce from 'lodash/debounce';
import { useRef } from 'react';

export const useDebouncedSearch = (callback: (value: any) => void, delay: number) => {
  return useRef(debounce((newValue) => callback(newValue), delay));
};
